import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
// import { config } from 'process';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaV3Service {
  
  constructor(
    /*private recaptchService : ReCaptchaV3Service,*/
    private httpClient : HttpClient) { }

  captchExecute(): Promise<any> {
  
    return new Promise((resolve, reject) => {
      //Attempt to validate the token
      // this.recaptchService.execute('submit').subscribe({
      //   next: (token) => { //Retrieve the recaptch token
      //     if(! token) {
      //       reject({ success: false});
      //     } else {
      //       resolve({success: true});
      //     }
          
      //     //Submit the token to use.
      //     // TODO: resolve this section
      //     // this.submitCaptchaToken(token).subscribe((response) => {
      //     //   if(! response['success']) {
      //     //     reject(response);
      //     //   } else {
      //     //     resolve(response);
      //     //   }
      //     // }); 
      //   },
      //   error: (error) => {
      //     console.log("Captcha token failed error: ", error);
      //     reject(error);
      //   }
      // });
    });

  }

  submitCaptchaToken(token: string): Observable<any> {
    let config = environment.captchaConfig;
    let uri = `https://${config.path.domain}`;
    let url = `${uri}/${config.path.api}`;
    let body = {
      'secret': config.secretKey,
      'response': token
    };

    let httpHeaders : HttpHeaders = new HttpHeaders({
      "Content-Type" : "application/json",
      "Accept" : "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST, GET" 
    });
    let options = {
      headers: httpHeaders
    };

    return this.httpClient.post(url, body, options);
  }  
}
